import { render } from "./AdminSidebar.vue?vue&type=template&id=735e1eb1"
const script = {}

import "./AdminSidebar.vue?vue&type=style&index=0&id=735e1eb1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__